<template>
  <transition name="fade" mode="out-in">
    <div class="services" v-smoothscroll="{ duration : 500 }">
      <servicesEntry></servicesEntry>
      <servicesVariant1></servicesVariant1>
      <servicesVariant2></servicesVariant2>
      <servicesVariant3></servicesVariant3>
      <servicesVariant4></servicesVariant4>
      <servicesVariant6></servicesVariant6>
      <servicesNextPage></servicesNextPage>
    </div>
  </transition>
</template>

<script>

export default {

}

</script>
